import React, { useState, useContext } from 'react';
import { AppBar, Avatar, InputBase, Toolbar, Menu, MenuItem, IconButton, Typography, Select, FormControl } from '@material-ui/core';
import { ZoneContext, ZONE_FR, ZONE_INT } from '../../context/index';
import PublicIcon from '@mui/icons-material/Public';
import { useHistory } from 'react-router-dom';
import styles from './styles.module.css';
import { Icon } from '../index';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

const TopBar = ({ avatarName, inputPlaceHolder = 'search..', navBarColor = '#2E3B55', searchable = false, logOut, userInfo }) => {
  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState(null);
  const { zone, changeZone } = useContext(ZoneContext);

  const isMenuOpen = Boolean(anchorEl);

  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleMyAccount = () => {
    handleCloseMenu();
    history.push('/my-account');
  };

  const handleLogout = async () => {
    handleCloseMenu();
    if (logOut) {
      await logOut();
    }
  };

  return (
    <div className={styles.root}>
      <AppBar position="relative" style={{ background: navBarColor }}>
        <Toolbar>
          {searchable && (
            <div className={styles.search}>
              <div className={styles.searchIcon}>
                <Icon name="search" type="solid" size={15} color="#000" />
              </div>
              <InputBase
                placeholder={inputPlaceHolder}
                classes={{
                  root: styles.inputRoot,
                  input: styles.inputInput,
                }}
                inputProps={{ 'aria-label': 'search' }}
              />
            </div>
          )}
          <div className={styles.grow} />
          <section className={styles.sectionDesktop}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginRight: 16,
                color: '#fff',
              }}
            >
              <PublicIcon style={{ marginRight: 8 }} />

              <FormControl variant="standard">
                <Select
                  value={zone}
                  onChange={(event) => changeZone(event.target.value)}
                  disableUnderline
                  style={{
                    color: '#fff',
                    fontWeight: 600,
                  }}
                  IconComponent={(props) => <ArrowDropDownIcon {...props} style={{ color: '#fff' }} />}
                >
                  <MenuItem value={ZONE_FR}>France</MenuItem>
                  <MenuItem value={ZONE_INT}>Internationale</MenuItem>
                </Select>
              </FormControl>
            </div>
            <IconButton onClick={handleAvatarClick}>
              <Avatar style={{ color: '#6200ee', background: '#fff', fontWeight: 700 }}>{avatarName}</Avatar>
            </IconButton>

            <Menu
              anchorEl={anchorEl}
              keepMounted
              open={isMenuOpen}
              onClose={handleCloseMenu}
              getContentAnchorEl={null}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
            >
              <div style={{ padding: '16px', minWidth: '280px', textAlign: 'center' }}>
                <Avatar
                  style={{
                    width: 64,
                    height: 64,
                    margin: '0 auto 12px auto',
                    background: '#6200ee',
                    color: '#fff',
                    fontSize: '22px',
                    fontWeight: 700,
                  }}
                >
                  {avatarName}
                </Avatar>

                <Typography variant="h6" style={{ fontWeight: 700 }}>
                  {userInfo?.preferred_username || userInfo?.login || ''}
                </Typography>

                <Typography variant="body1" style={{ color: '#7a7a7a', wordBreak: 'break-word' }}>
                  {userInfo?.email || ''}
                </Typography>
              </div>

              <MenuItem onClick={handleMyAccount}>My Account</MenuItem>
              <MenuItem onClick={handleLogout}>Logout</MenuItem>
            </Menu>
          </section>
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default TopBar;
